import { useMemo, useState } from 'react';

import { Icons, IconsTypes } from '../Icons';

type Collapse = {
  title: string;
  description: string;
};

export default function Collapse({ title = '', description = `` }: Collapse) {
  const [isCollapsed, setCollapsed] = useState(false);

  function handleCollapse() {
    setCollapsed((isCollapsedPrev) => !isCollapsedPrev);
  }

  const collapseStyles = useMemo(() => {
    return {
      true: {
        icon: 'bg-green origin-center rotate-90 text-white',
        container: 'border-green drop-shadow-[0px_5px_16px_0px_rgba(36, 126, 128, 0.20)]',
        content: 'opacity-100 grid-rows-[1fr] pt-4',
      },
      false: {
        icon: 'bg-white text-black-600',
        container: 'border-transparent drop-shadow-[0px_5px_16px_0px_rgba(50, 54, 66, 0.06)]',
        content: 'opacity-0 pt-0 grid-rows-[0fr]',
      },
    }[`${isCollapsed}`];
  }, [isCollapsed]);

  const animation = 'transition-all duration-300 ease-in';

  return (
    <button
      type="button"
      onClick={handleCollapse}
      className={`mb-3 w-full overflow-hidden rounded-lg border bg-white p-6 text-left md:mb-5 md:rounded-xl md:px-8 md:py-9 ${animation} ${collapseStyles.container}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex w-[calc(100%-78px)] items-center">
          <h3 className="text-base font-bold md:text-h3-sm">{title}</h3>
        </div>
        <div
          className={`flex h-10 w-10 items-center justify-center rounded-full drop-shadow-[0_6px_8px_rgba(0,0,0,0.05)] ${animation} ${collapseStyles.icon}`}
        >
          <Icons name={IconsTypes.ARROW_RIGHT} iconProps={{ width: 14, viewBox: '0 0 5 14' }} />
        </div>
      </div>
      <div className={`grid grid-flow-col ${animation} ${collapseStyles.content}`}>
        <div className="overflow-hidden">
          <p className={`weight whitespace-pre-line font-normal text-[#545969] md:w-[calc(100%-78px)]`}>
            {description}
          </p>
        </div>
      </div>
    </button>
  );
}
